<template>
  <div class="body-main">


    <div class="cart-header">
      <div class="cart-header-warp clearfix">
        <div class="cart-title left clearfix">
          <h1 class="left">支付中心</h1>

        </div>
      </div>
    </div>

    <div class="cart-body" >
      <div class="cart-body-title">
        <div class="clearfix">
          <div class="left trade-title">
            <span class="order">订单号：</span><span class="num">{{this.id}}</span>
          </div>

        </div>
        <div class="detail-box">
          <ul>
            <li class="clearfix js-item-cart js-each-1192" >
              <img :src="this.baseUrl+this.orderInfo.pic_url" alt="" class="l">
              <div class="text-info-box l">
                <p class="package-title"></p>
                <a >
                  <p class="package-info-title">{{this.orderInfo.title}}</p>
                </a>
              </div>
              <div class="info-price l">
                <span v-if="this.orderInfo.order_status == '10'" class="price-text">实付金额：</span>
                <span v-if="this.orderInfo.order_status == '20'" class="price-text">已付金额：</span>
                <em>￥</em>
                <span class="price">{{this.orderInfo.charge}}</span>

              </div>
            </li>
          </ul>
        </div>
        <div class="pay-method">
          <h2 class="pay-method-title">支付方式</h2>
          <ul class="clearfix js-pay-method">
            <li class="pay-way alipay active" >

            </li>

          </ul>


        </div>
        <div class="pay-summary clearfix huabei-active">


          <div class="summary">
            <div class="clearfix total">
              <span class="label">支付状态：</span>
              <span class="price">
                <span v-if="this.orderInfo.order_status == '10'">待支付</span>
                <span v-if="this.orderInfo.order_status == '20'">已支付</span>

              </span>
            </div>
            <div class="clearfix total">
              <span v-if="this.orderInfo.order_status == '10'" class="label">应付金额：</span>
              <span v-if="this.orderInfo.order_status == '20'" class="label">已付金额：</span>
              <span class="price">
                <em>￥</em>
                <span>{{this.orderInfo.charge}}</span>
              </span>
            </div>

            <div class="submit-warp clearfix">
              <span v-if="this.orderInfo.order_status == '10'" @click="goPay()"  class="pay-summary-submit js-pay-submit">立即支付</span>
              <span v-if="this.orderInfo.order_status == '20'" @click="goStudy()" class="pay-summary-submit js-pay-submit">去学习</span>
            </div>
          </div>
        </div>

      </div>
    </div>


  </div>
</template>

<script>
  import { getAdvanceOrderInfo ,getPay} from '@/api/order'
    export default {
      name: "pay",
      props:[
        'id'
      ],
      data(){
        return{
          orderInfo:{}
        }
      },
      created(){
        this.getOrderInfo()
      },
      methods:{
        getOrderInfo(){
          getAdvanceOrderInfo(this.id).then(res=>{
            this.orderInfo = res.data

          })
        },
        goPay(){
          // getPay(this.id).then(res)
          // alert(this.baseBackUrl + "alipay/goPay?orderId=" + this.id);

          window.location.href = this.baseBackUrl + "alipay/goAlipay?orderId=" + this.id;
        },
        goStudy(){
          if(this.orderInfo.type===1){
            this.$router.push({ name: 'VideoDetail', params: {id: this.orderInfo.id}})
          }else if(this.orderInfo.type === 2) {
            this.$router.push({ name: 'Article', params: {id: this.orderInfo.id}})
          }

        }
      }
    }
</script>

<style scoped>

  blockquote, body, button, code, dd, div, dl, dt, fieldset, form, h1, h2, h3, h4, h5, h6, input, legend, li, ol, p, pre, td, textarea, th, ul {
    margin: 0;
    padding: 0;
  }
  .body-main {
    min-height: 800px;
    background: #fff;
    color: #5e5e5e;
    font: 14px/2em "PingFang SC","微软雅黑","Microsoft YaHei",Helvetica,"Helvetica Neue",Tahoma,Arial,sans-serif;
  }
  .cart-header {
    margin-top: 10px;
    height: 160px;
    background-color: #e3e6e9;
    background: url(./../../assets/img/order/cart-header-bg.jpg) repeat-x left bottom;
  }
  .cart-header .cart-header-warp {
    width: 1104px;
    height: 120px;
    line-height: 120px;
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;
  }
  .cart-header .cart-title {
    color: #4d555d;
    font-weight: 200;
    font-size: 14px;
  }
  .cart-header .left {
    float: left;
  }
  .cart-header .cart-title h1 {
    font-size: 32px;
    line-height: 115px;
    margin-right: 25px;
    color: #07111b;
    font-weight: 200;
  }
  .cart-body {
    width: 1152px;
    padding: 0 36px 32px;
    background-color: #fff;
    margin-top: -40px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 8px 16px 0 rgba(7,17,27,.1);
    border-radius: 8px;
    box-sizing: border-box;
  }
  .cart-body .cart-body-title {
    border-bottom: 0;
  }

  .cart-body .cart-body-title {
    min-height: 88px;
    /*line-height: 88px;*/
    border-bottom: 0px solid #e1e5e9;
    box-sizing: border-box;
  }
  .cart-body .cart-body-title .trade-title {
    line-height: 16px;
    padding-top: 36px;
    padding-bottom: 24px;
  }

  .cart-body .left {
    float: left!important;
  }
  .cart-body .cart-body-title .trade-title .order {
    font-size: 16px;
    color: #07111b;
  }
  .cart-body .cart-body-title .num {
    font-size: 16px;
    color: #070000;
  }

  .l {
    float: left;
  }
  .detail-box {
    width: 100%;
  }
  .detail-box ul {
    width: 100%;
    padding-bottom: 15px;
    border-bottom: 1px solid #d9dde1;
  }
  ol, ul {
    list-style: none;
  }
  .detail-box ul li:last-child {
    margin-bottom: 0;
  }

  .detail-box ul li {
    padding: 24px;
    box-sizing: border-box;
    background: #f3f5f7;
    margin-bottom: 1px;
  }
  .clearfix:after {
    content: '\0020';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .content{
    width: 1200px;
    margin: auto;
  }

  blockquote, body, button, code, dd, div, dl, dt, fieldset, form, h1, h2, h3, h4, h5, h6, input, legend, li, ol, p, pre, td, textarea, th, ul {
    margin: 0;
    padding: 0;
  }
  a:link, a:visited {
    color: #5e5e5e;
  }
  :link, :visited, ins {
    text-decoration: none;
  }
  a {
    background-color: transparent;
  }
  user agent stylesheet
  a:-webkit-any-link {
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-box ul li img {
    width: 160px;
    height: 90px;
    margin-right: 24px;
  }

  fieldset, img {
    border: 0;
  }
  .detail-box ul li .text-info-box {
    width: 462px;
    height: 90px;
    margin-right: 120px;
  }
  .detail-box ul li .text-info-box .package-title {
    margin-top: 8px;
    font-size: 12px;
    color: #07111b;
    line-height: 24px;
  }
  .detail-box ul li .text-info-box .package-info-title {
    margin: 0;
    font-size: 16px;
    color: #07111b;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .detail-box ul li .info-price {
    position: relative;
    margin-top: 35px;
    width: 200px;
    font-size: 16px;
    color: #f01414;
  }
  .detail-box ul li .info-price .price {
    display: inline-block;
    width: 85px;
  }
  .price-text {
    font-size: 14px;
    color: #93999f;
  }

/*  支付方式*/
  .cart-body .pay-method {
    padding: 15px 12px 20px;
    border-top: 0px solid #d9dde1;
    border-bottom: 1px solid #d9dde1;
  }
  .cart-body .pay-method .pay-method-title {
    height: 46px;
    line-height: 30px;
    font-size: 16px;
    color: #07111b;
  }

  h1, h2, h3, h4, h5, h6 {
    font-size: 100%;
    font-weight: 400;
    font: 14px/2em "PingFang SC","微软雅黑","Microsoft YaHei",Helvetica,"Helvetica Neue",Tahoma,Arial,sans-serif;
  }
  ol, ul {
    list-style: none;
  }
  .cart-body .pay-method .pay-way.active {
    border-color: #f01414;
  }

  .cart-body .pay-method .alipay {
    background-position: 33px -304px;
    background-repeat: no-repeat;
  }
  .cart-body .pay-method li {
    float: left;
    margin-right: 18px;
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    width: 192px;
    height: 86px;
    background-color: #f3f5f7;
    border: 2px solid #f3f5f7;
    cursor: pointer;
    background-image: url(./../../assets/img/order/pay_s.png);
  }
  .cart-body .pay-method .pay-way.active .bottomright {
    display: block;
  }

  .cart-body .pay-method .bottomright {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0;
    bottom: 0;
    display: none;
  }
  .cart-body .pay-method .triangle {
    width: 0;
    height: 0;
    border-bottom: 20px solid red;
    border-left: 20px solid transparent;
  }
  .cart-body .pay-method .bottomright i {
    position: absolute;
    right: -1px;
    bottom: 0;
    color: #fff;
    font-size: 12px;
  }

  [class^="imv2-"], [class*=" imv2-"] {
    font-family: 'imv2' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    letter-spacing: 0;
    -webkit-font-feature-settings: "liga";
    -moz-font-feature-settings: "liga=1";
    -moz-font-feature-settings: "liga";
    -ms-font-feature-settings: "liga" 1;
    font-feature-settings: "liga";
    -webkit-font-variant-ligatures: discretionary-ligatures;
    font-variant-ligatures: discretionary-ligatures;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .cart-body .pay-summary .summary {
    float: right;
    padding-top: 36px;
  }
  .cart-body .pay-summary .total {
    height: 24px;
    margin-top: 10px;
  }
  .cart-body .pay-summary .total .label {
    line-height: 26px;
  }

  .cart-body .pay-summary .label {
    width: 96px;
    font-size: 14px;
    color: #07111b;
    height: 20px;
    text-align: right;
    float: left;
    line-height: 20px;
  }
  .cart-body .pay-summary .total .price {
    font-size: 24px;
    line-height: 24px;
    height: 24px;
  }

  .cart-body .pay-summary .price {
    font-size: 14px;
    color: #f01414;
    height: 20px;
    text-align: right;
    line-height: 20px;
    float: left;
  }
  .cart-body .price {
    color: #f01414;
  }
  .cart-body .pay-summary .price em, .cart-body .pay-summary .price span {
    float: none;
  }

  em {
    font-style: normal;
  }
  .cart-body .pay-summary .submit-warp {
    margin-top: 32px;
    margin-bottom: 16px;
  }
  .cart-body .pay-summary .pay-summary-submit {
    float: right;
    width: 140px;
    height: 40px;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    background-color: #f01414;
    border-radius: 2px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/pay/pay.vue